import { useState } from "react";
import axios from "axios";
import { Lock, Download, RefreshCw } from "lucide-react";
import { API } from "@/lib/api";

export default function Admin() {
  const [token, setToken] = useState("");
  const [authed, setAuthed] = useState(false);
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async (tk) => {
    setLoading(true); setErr("");
    try {
      const res = await axios.get(`${API}/registrations?token=${encodeURIComponent(tk)}`, { headers: { "X-Admin-Token": tk } });
      setRows(res.data);
      setAuthed(true);
    } catch (e) {
      setErr("Token non valido."); setAuthed(false);
    } finally { setLoading(false); }
  };

  if (!authed) {
    return (
      <div className="min-h-screen bg-ink flex items-center justify-center px-5">
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 w-full max-w-sm">
          <Lock className="text-bordeaux mb-4" size={32} />
          <h1 className="font-display uppercase text-2xl mb-4">Area amministrazione</h1>
          <input type="password" value={token} onChange={(e) => setToken(e.target.value)} placeholder="Token amministratore"
            className="w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white outline-none focus:border-bordeaux" data-testid="admin-token" />
          {err && <p className="text-red-300 text-sm mt-2">{err}</p>}
          <button onClick={() => load(token)} disabled={loading} className="mt-4 w-full bg-bordeaux hover:bg-[#c8164b] text-white font-bold py-3 rounded-full" data-testid="admin-login">
            {loading ? "Verifica…" : "Accedi"}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-ink text-white px-5 py-10">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <h1 className="font-display uppercase text-3xl">Iscrizioni · {rows.length}</h1>
          <div className="flex gap-3">
            <button onClick={() => load(token)} className="flex items-center gap-2 border border-white/20 rounded-full px-4 py-2 text-sm"><RefreshCw size={16} /> Aggiorna</button>
            <a href={`${API}/registrations/export?token=${encodeURIComponent(token)}`} className="flex items-center gap-2 bg-bordeaux rounded-full px-4 py-2 text-sm font-bold"><Download size={16} /> CSV</a>
          </div>
        </div>
        <div className="overflow-x-auto rounded-xl border border-white/10">
          <table className="w-full text-sm" data-testid="admin-table">
            <thead className="bg-white/5 text-white/70 text-left">
              <tr>{["Data", "Nome", "Email", "Tel.", "Età", "Città", "Famiglia", "Strumento", "Studio", "Dove", "Email✓"].map((h) => <th key={h} className="px-3 py-2 whitespace-nowrap">{h}</th>)}</tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-white/10">
                  <td className="px-3 py-2 whitespace-nowrap">{new Date(r.created_at).toLocaleDateString("it-IT")}</td>
                  <td className="px-3 py-2 whitespace-nowrap font-semibold">{r.nome}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.email}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.telefono}</td>
                  <td className="px-3 py-2">{r.eta}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.citta}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.famiglia}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.strumento}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.anni_studio}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{r.contesto}</td>
                  <td className="px-3 py-2">{r.emailed ? "✓" : "—"}</td>
                </tr>
              ))}
              {rows.length === 0 && <tr><td colSpan={11} className="px-3 py-8 text-center text-white/50">Nessuna iscrizione.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
